export { default as theme } from 'prism-themes/themes/prism-hopscotch.css';
